export const FILTERS_MENU = 'filters';
export const STAFFING_SETTINGS = 'staffing-settings';
export const HOURS_SETTINGS = 'hours-settings';
export const INVENTORY_SETTINGS = 'inventory-settings';
export const NAVIGATION_MENU = 'navigation';

export const MENU_OPTIONS = [FILTERS_MENU, STAFFING_SETTINGS, HOURS_SETTINGS, NAVIGATION_MENU];
